import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NimmstaCommonsModuleConfiguration } from '@nimmsta/ng-commons-lib/config';
import { InputWithErrorComponent } from '@nimmsta/ng-commons-lib/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dataconnection-configuration',
  templateUrl: './dataconnection-configuration.component.html',
  imports: [InputWithErrorComponent, TranslatePipe],
  host: { class: 'accordion mt-3' },
})
export class DataConnectionConfigurationComponent {
  private static nextId = 0;
  private readonly configuration = inject(NimmstaCommonsModuleConfiguration);

  @Input() invalid = false;

  @Input({ required: true }) control!: FormControl<unknown>;
  @Output() keyUpEvent = new EventEmitter<KeyboardEvent>();

  readonly panelId = `data-connection-config-${DataConnectionConfigurationComponent.nextId++}`;
  readonly documentationUrl = `${(
    this.configuration.applicationUrls.documentation ??
    'https://docs.nimmsta.com/platform'
  ).replace(/\/+$/, '')}/5-data-sources/5.6-csv-sorting-settings/`;
  expanded = false;
}
